import { ContentBlock } from "../Shared/Content/ContentBlock";
import { ContentBody } from "../Shared/Content/ContentBody";

interface IProps {
    fieldTestimonial: any
}

export const Testimonial = ({ fieldTestimonial }: IProps) => {

    // set base testimonial variable
    let testimonialByline = fieldTestimonial.fieldName;
    // only append comma [space] if field has data
    if (fieldTestimonial.fieldRole) {
        // append role
        testimonialByline += ', ' + fieldTestimonial.fieldRole;
    }
    // only append comma [space] if field has data
    if (fieldTestimonial.fieldOrganizationName) {
        // append org name
        testimonialByline += ', ' + fieldTestimonial.fieldOrganizationName;
    }

    return (
        <ContentBlock className="programOverviewTestimonial">
            <ContentBody>
                <div className="testimonialBody">
                    <div className="body" dangerouslySetInnerHTML={{ __html: fieldTestimonial.fieldQuote }} />
                    <div className="signature" dangerouslySetInnerHTML={{ __html: testimonialByline }} />
                </div>
            </ContentBody>
        </ContentBlock>
    );
};
